import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useForm } from 'react-hook-form';

import Filter from './filter'
import Map from './map'
import List from '../map/list'
import Teaser from './teaser'

import { deburr } from 'lodash'


const topo50chathams = [
  'chatham',
  'pitt island',
  'owenga',
  'waitangi',
  'ci03',
  'cape young',
  'point somes'
]

const MapChooserApp = ({ endpoint, defaultCentre, defaultZoom, defaultOverlay, api_key }) => {


  const { register, handleSubmit, resetField, getValues, setValue, watch, defaultValues } = useForm({
    defaultValues: {
      keywords: '',
    }
  });


    const { isLoading, error, data } = useQuery(endpoint, async () => {
        return await fetch(endpoint, {
          headers: new Headers({
            'content-type': 'application/json'
          })
        }).then(async res => {
          if(res.ok) {
            return await res.json()
          }
          throw await res.json();
        })
        .then(items => {
          return items.map(item => {
            let geodata = item.geodata

            if(topo50chathams.some(kw => item.kw.includes(kw))){
              geodata = {
                type: geodata.type,
                coordinates: geodata.coordinates.map(polygon => {
                  return polygon.map(coords => ([
                    coords[0] + 360,
                    coords[1]
                  ]))
                })
              }
            }

            return {
              ...item,
              geodata
            }
          })
        })
      }
    )

    const [ filtered, setFiltered ] = useState([])
    const [ role, setRole ] = useState('');

    useEffect(() => {
      if(data) {
        setFiltered(applyFilters({ data, keywords: '' }));
      }
    }, [ data ]);

    if(isLoading) {
        return <div className="spinner">&nbsp;</div>;
    }

    const onFilter = ({ keywords, type }) => {
      let clone = [...data];

      if(keywords.length > 2) {
        // do filtering
        const lc = keywords.toLowerCase();
        clone = clone.filter(({ kw }) => {
          return kw.includes(lc)
        })
      }

      setFiltered(clone);
      setRole('status')
    }


    const onReset = () => {
      setValue('keywords', '');
      setFiltered(applyFilters({ data, keywords: ''}))
      setRole('');
    }


    return (

      <div className={`map-chooser__app map__app`}>
        <Filter
          id={`mc`}
          //types={types}
          register={register}
          handleSubmit={handleSubmit(onFilter)}
          onReset={onReset}
          filters={{
            keywords: '',
            //type: 'Topo50'
          }}
        />
        {filtered && (
          <div className="map__controls" role={role}>
            <h3>{`Showing ${filtered.length} location${filtered.length === 1 ? '' : 's'}`}</h3>
          </div>
        )}
        {filtered && <List data={filtered} Elem={Teaser} />}
        <Map data={filtered} defaultOverlay={defaultOverlay} size={filtered.length <= 31 ? 'sm' : 'md'} />

      </div>
    )
}
export default MapChooserApp

const applyFilters = ({ data, keywords, type }) => {
  let clone = [...data];

  if(keywords && keywords.length > 2) {
    // do filtering
    const lc = keywords.toLowerCase();
    clone = clone.filter(({ kw }) => {
      return kw.includes(lc)
    })
  }
/*
  if(type) {
    clone = clone.filter(({ type }) => field_map_type === type)
  }*/
  return clone;
}
